import "./_import_files";
import svg4everybody from "svg4everybody";
import $ from "jquery";
import Page from "webPage/Page";


$(function () {
    document.documentElement.setAttribute('data-useragent', navigator.userAgent);
    if (!!window.MSInputMethodContext && !!document.documentMode) {
        $('html').addClass('ie11');
    }

    svg4everybody();
    Page.init();

    $('body').on('click', '.js-toggle-navigation', () => {
        $('body').toggleClass('body-show-navigation');
        return false;
    }).on('click', '.js-close-navigation', () => {
        $('body').removeClass('body-show-navigation');
        return false;
    }).on('click', '.js-category-dropdown', function () {
        $(this).parent().toggleClass('category-select--active');
        $(this).parent().find('.category-select__dropdown').toggle();
        return false;
    }).on("click", (e) => {
        if($(e.target).closest('.category-select').length === 0) {
            $(".category-select__dropdown").hide();
            $(".category-select").removeClass('category-select--active');
        }
    }).on('change', '.js-dropdown input', function () {
        let text;

        let $inputs = $('.js-dropdown input')
        let $checkedInputs = $inputs.filter(":checked")

        if ($checkedInputs.length === 0 || $checkedInputs.length === $inputs.length) {
            text = 'All Documents';
        } else if($checkedInputs.length === 1) {
            text = $('.js-dropdown input:checked').parent().find('span').text();
        } else  {
            text = $checkedInputs.length + " Categories";
        }

        $('.js-main-category-text').text(text);
    }).on('click', '.js-search-toggle', function () {
        $('.search-bar-mobile').toggleClass('search-bar-mobile--active');
        $('.js-toggle').stop().slideToggle(300);
        return false;
    });

    if (window.CATEGORIES_ACTIVE) {
        $(window).on('resize', () => {
            if ($(window).outerWidth() > 599) {
                $('.search-bar-mobile').removeClass('search-bar-mobile--active');
                $('.js-toggle').show();
            } else {
                $('.js-toggle').hide();
            }
        });
    }

});
